import { isFn } from '~/lib/lang/mod.type.js';
import { last } from '~/lib/arr/mod.js';

/**
 * @module lib/fn Utilities for functions
 */
export * from './compose.js';
export * from './identity.js';
export * from './noop.js';

/**
 * A cleaner utility in place of using an IIFE
 *
 * ```js
 * apply((a, b, c) => a + b + c, Number(new Date()), 10, n10)
 *
 * apply(Number(new Date()), 10, n10, (a, b, c) => a + b + c)
 * ```
 */
export const apply = (...values) => {
	if (!values.length) {
		return null;
	}

	const fn =
		isFn(values[0]) ? values.shift()
		: isFn(last(values)) ? values.pop()
		: undefined;

	if (fn) {
		return fn(...values);
	}

	return fn => fn(...values);
};
